import Icon from '../components/Icon.vue'

Icon.register({
  'envelope-open-text': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M176 216c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-160zM160 296v-16c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-160c-8.8 0-16-7.2-16-16zM256 417.1c16.4 0 32.8-5.1 46.9-15.2l209.1-151.1v213.1c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-213.1l209.1 151.1c14 10.1 30.4 15.2 46.9 15.2zM493.6 162.9c11.6 9.1 18.4 23 18.4 37.8v10.7l-96 69.3v-184.7h-320v184.7l-96-69.3v-10.7c0-12.9 8.2-29.8 18.4-37.8 8.9-6.9 17.2-13.5 29.6-22.8v-44.1c0-26.5 21.5-48 48-48h77.5c3-2.2 5.9-4.3 9-6.6 16.8-12.3 50.2-41.8 73.4-41.4 23.2-0.3 56.6 29.2 73.4 41.4 3.2 2.3 6 4.4 9 6.6h77.5c26.5 0 48 21.5 48 48v44.1c12.4 9.3 20.8 15.9 29.6 22.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/envelope-open-text.js
// module id = 1300
// module chunks = 0